import React from "react";
import Chart from "react-apexcharts";
import {
  Card,
  CardBody,
  CardHeader,
  Typography,
} from "@material-tailwind/react";
import { useTranslation } from "react-i18next";

const WeeklyChart = ({ data = [] }) => {
  const { t } = useTranslation("home");
  const categories = data.map((item) => item.day);

  const series = [
    {
      name: "Collection",
      data: data.map((item) => Number(item.amount)),
    },
  ];

  const total = data.reduce(
    (sum, item) => sum + Number(item.amount),
    0
  );

  const options = {
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
    },

    plotOptions: {
      bar: {
        borderRadius: 6,
        columnWidth: "45%",
      },
    },

    dataLabels: {
      enabled: false,
    },

    xaxis: {
      categories,
    },

    yaxis: {
      labels: {
        formatter: (val) => "SAR" + val.toLocaleString(),
      },
    },

    tooltip: {
      y: {
        formatter: (val) => "SAR" + val.toLocaleString(),
      },
    },

    colors: ["#22c55e"],

    grid: {
      borderColor: "#ECEFF1",
      strokeDashArray: 4,
    },
  };

  return (
    <Card className="shadow-md">
      <CardHeader
        floated={false}
        shadow={false}
        className="bg-white rounded-none px-6 py-4"
      >
        <div className="flex justify-between items-center">
          <div>
            <Typography variant="h5">
              {t('weeklyCollection')}
            </Typography>

            {/* <Typography
              variant="small"
              color="gray"
            >
              Current week's payment collection
            </Typography> */}
          </div>

          {/* <div className="text-right">
            <Typography
              variant="small"
              color="gray"
            >
              Total
            </Typography>

            <Typography
              variant="h5"
              color="green"
            >
              SAR{total.toLocaleString()}
            </Typography>
          </div> */}
        </div>
      </CardHeader>

      <CardBody>
        <Chart
          type="bar"
          height={350}
          options={options}
          series={series}
        />
      </CardBody>
    </Card>
  );
};

export default WeeklyChart;